var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { staticClass: "text-center py-12", attrs: { cols: "12" } },
        [
          _c(
            "v-row",
            {
              staticClass: "mb-5",
              attrs: { align: "center", justify: "center", "no-gutters": "" },
            },
            [
              _c("v-img", {
                attrs: {
                  contain: "",
                  height: "500",
                  src: require(`@/assets/empty-state/appAsset-http--404-ax.svg`),
                },
              }),
            ],
            1
          ),
          _c("span", { staticClass: "d-block subtitle-2 font-weight-bold" }, [
            _vm._v("Al parecer estás perdido"),
          ]),
          _c(
            "v-btn",
            {
              staticClass: "mt-5",
              attrs: {
                to: { name: "AccountDashboard" },
                width: 220,
                color: "grey-900",
              },
            },
            [_vm._v("Volver al inicio")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }